/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onNewUnreadMessage = /* GraphQL */ `
  subscription OnNewUnreadMessage {
    onNewUnreadMessage {
      submissionId
      conversationId
      unreadCount
      lastMessagePreview
      timestamp
      mobileNumber
      __typename
    }
  }
`;
export const onCreateSubmission = /* GraphQL */ `
  subscription OnCreateSubmission(
    $filter: ModelSubscriptionSubmissionFilterInput
  ) {
    onCreateSubmission(filter: $filter) {
      id
      publicId
      SID
      createdAt
      mobilenumber
      age
      gender
      householdincome
      sendwelcomesms
      state
      transgender
      updatedAt
      zipcode
      Status
      updatedBy
      Notes
      userscore
      eligible
      needsAlternateTime
      alternateTimeRequestedAt
      conversations {
        nextToken
        __typename
      }
      appointments {
        nextToken
        __typename
      }
      statusHistory {
        nextToken
        __typename
      }
      messageVariants {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const onUpdateSubmission = /* GraphQL */ `
  subscription OnUpdateSubmission(
    $filter: ModelSubscriptionSubmissionFilterInput
  ) {
    onUpdateSubmission(filter: $filter) {
      id
      publicId
      SID
      createdAt
      mobilenumber
      age
      gender
      householdincome
      sendwelcomesms
      state
      transgender
      updatedAt
      zipcode
      Status
      updatedBy
      Notes
      userscore
      eligible
      needsAlternateTime
      alternateTimeRequestedAt
      conversations {
        nextToken
        __typename
      }
      appointments {
        nextToken
        __typename
      }
      statusHistory {
        nextToken
        __typename
      }
      messageVariants {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const onDeleteSubmission = /* GraphQL */ `
  subscription OnDeleteSubmission(
    $filter: ModelSubscriptionSubmissionFilterInput
  ) {
    onDeleteSubmission(filter: $filter) {
      id
      publicId
      SID
      createdAt
      mobilenumber
      age
      gender
      householdincome
      sendwelcomesms
      state
      transgender
      updatedAt
      zipcode
      Status
      updatedBy
      Notes
      userscore
      eligible
      needsAlternateTime
      alternateTimeRequestedAt
      conversations {
        nextToken
        __typename
      }
      appointments {
        nextToken
        __typename
      }
      statusHistory {
        nextToken
        __typename
      }
      messageVariants {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const onCreateSubmissionStatusHistory = /* GraphQL */ `
  subscription OnCreateSubmissionStatusHistory(
    $filter: ModelSubscriptionSubmissionStatusHistoryFilterInput
  ) {
    onCreateSubmissionStatusHistory(filter: $filter) {
      id
      submissionId
      submission {
        id
        publicId
        SID
        createdAt
        mobilenumber
        age
        gender
        householdincome
        sendwelcomesms
        state
        transgender
        updatedAt
        zipcode
        Status
        updatedBy
        Notes
        userscore
        eligible
        needsAlternateTime
        alternateTimeRequestedAt
        __typename
      }
      previousStatus
      newStatus
      changedAt
      changedBy
      reason
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateSubmissionStatusHistory = /* GraphQL */ `
  subscription OnUpdateSubmissionStatusHistory(
    $filter: ModelSubscriptionSubmissionStatusHistoryFilterInput
  ) {
    onUpdateSubmissionStatusHistory(filter: $filter) {
      id
      submissionId
      submission {
        id
        publicId
        SID
        createdAt
        mobilenumber
        age
        gender
        householdincome
        sendwelcomesms
        state
        transgender
        updatedAt
        zipcode
        Status
        updatedBy
        Notes
        userscore
        eligible
        needsAlternateTime
        alternateTimeRequestedAt
        __typename
      }
      previousStatus
      newStatus
      changedAt
      changedBy
      reason
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteSubmissionStatusHistory = /* GraphQL */ `
  subscription OnDeleteSubmissionStatusHistory(
    $filter: ModelSubscriptionSubmissionStatusHistoryFilterInput
  ) {
    onDeleteSubmissionStatusHistory(filter: $filter) {
      id
      submissionId
      submission {
        id
        publicId
        SID
        createdAt
        mobilenumber
        age
        gender
        householdincome
        sendwelcomesms
        state
        transgender
        updatedAt
        zipcode
        Status
        updatedBy
        Notes
        userscore
        eligible
        needsAlternateTime
        alternateTimeRequestedAt
        __typename
      }
      previousStatus
      newStatus
      changedAt
      changedBy
      reason
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateConversation = /* GraphQL */ `
  subscription OnCreateConversation(
    $filter: ModelSubscriptionConversationFilterInput
  ) {
    onCreateConversation(filter: $filter) {
      id
      submissionId
      submission {
        id
        publicId
        SID
        createdAt
        mobilenumber
        age
        gender
        householdincome
        sendwelcomesms
        state
        transgender
        updatedAt
        zipcode
        Status
        updatedBy
        Notes
        userscore
        eligible
        needsAlternateTime
        alternateTimeRequestedAt
        __typename
      }
      createdAt
      lastMessageTime
      updatedAt
      status
      unreadCount
      lastMessageContent
      lastMessageDirection
      twilioConversationSid
      messages {
        nextToken
        __typename
      }
      participants {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const onUpdateConversation = /* GraphQL */ `
  subscription OnUpdateConversation(
    $filter: ModelSubscriptionConversationFilterInput
  ) {
    onUpdateConversation(filter: $filter) {
      id
      submissionId
      submission {
        id
        publicId
        SID
        createdAt
        mobilenumber
        age
        gender
        householdincome
        sendwelcomesms
        state
        transgender
        updatedAt
        zipcode
        Status
        updatedBy
        Notes
        userscore
        eligible
        needsAlternateTime
        alternateTimeRequestedAt
        __typename
      }
      createdAt
      lastMessageTime
      updatedAt
      status
      unreadCount
      lastMessageContent
      lastMessageDirection
      twilioConversationSid
      messages {
        nextToken
        __typename
      }
      participants {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const onDeleteConversation = /* GraphQL */ `
  subscription OnDeleteConversation(
    $filter: ModelSubscriptionConversationFilterInput
  ) {
    onDeleteConversation(filter: $filter) {
      id
      submissionId
      submission {
        id
        publicId
        SID
        createdAt
        mobilenumber
        age
        gender
        householdincome
        sendwelcomesms
        state
        transgender
        updatedAt
        zipcode
        Status
        updatedBy
        Notes
        userscore
        eligible
        needsAlternateTime
        alternateTimeRequestedAt
        __typename
      }
      createdAt
      lastMessageTime
      updatedAt
      status
      unreadCount
      lastMessageContent
      lastMessageDirection
      twilioConversationSid
      messages {
        nextToken
        __typename
      }
      participants {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const onCreateMessage = /* GraphQL */ `
  subscription OnCreateMessage($filter: ModelSubscriptionMessageFilterInput) {
    onCreateMessage(filter: $filter) {
      id
      conversationId
      conversation {
        id
        submissionId
        createdAt
        lastMessageTime
        updatedAt
        status
        unreadCount
        lastMessageContent
        lastMessageDirection
        twilioConversationSid
        __typename
      }
      content
      name
      direction
      phoneNumber
      timestamp
      read
      readAt
      messageSid
      mediaUrls
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateMessage = /* GraphQL */ `
  subscription OnUpdateMessage($filter: ModelSubscriptionMessageFilterInput) {
    onUpdateMessage(filter: $filter) {
      id
      conversationId
      conversation {
        id
        submissionId
        createdAt
        lastMessageTime
        updatedAt
        status
        unreadCount
        lastMessageContent
        lastMessageDirection
        twilioConversationSid
        __typename
      }
      content
      name
      direction
      phoneNumber
      timestamp
      read
      readAt
      messageSid
      mediaUrls
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteMessage = /* GraphQL */ `
  subscription OnDeleteMessage($filter: ModelSubscriptionMessageFilterInput) {
    onDeleteMessage(filter: $filter) {
      id
      conversationId
      conversation {
        id
        submissionId
        createdAt
        lastMessageTime
        updatedAt
        status
        unreadCount
        lastMessageContent
        lastMessageDirection
        twilioConversationSid
        __typename
      }
      content
      name
      direction
      phoneNumber
      timestamp
      read
      readAt
      messageSid
      mediaUrls
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateParticipant = /* GraphQL */ `
  subscription OnCreateParticipant(
    $filter: ModelSubscriptionParticipantFilterInput
  ) {
    onCreateParticipant(filter: $filter) {
      id
      conversationId
      conversation {
        id
        submissionId
        createdAt
        lastMessageTime
        updatedAt
        status
        unreadCount
        lastMessageContent
        lastMessageDirection
        twilioConversationSid
        __typename
      }
      phoneNumber
      twilioSid
      name
      role
      isRequired
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateParticipant = /* GraphQL */ `
  subscription OnUpdateParticipant(
    $filter: ModelSubscriptionParticipantFilterInput
  ) {
    onUpdateParticipant(filter: $filter) {
      id
      conversationId
      conversation {
        id
        submissionId
        createdAt
        lastMessageTime
        updatedAt
        status
        unreadCount
        lastMessageContent
        lastMessageDirection
        twilioConversationSid
        __typename
      }
      phoneNumber
      twilioSid
      name
      role
      isRequired
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteParticipant = /* GraphQL */ `
  subscription OnDeleteParticipant(
    $filter: ModelSubscriptionParticipantFilterInput
  ) {
    onDeleteParticipant(filter: $filter) {
      id
      conversationId
      conversation {
        id
        submissionId
        createdAt
        lastMessageTime
        updatedAt
        status
        unreadCount
        lastMessageContent
        lastMessageDirection
        twilioConversationSid
        __typename
      }
      phoneNumber
      twilioSid
      name
      role
      isRequired
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateDuplicateSubmission = /* GraphQL */ `
  subscription OnCreateDuplicateSubmission(
    $filter: ModelSubscriptionDuplicateSubmissionFilterInput
  ) {
    onCreateDuplicateSubmission(filter: $filter) {
      id
      SID
      createdAt
      mobilenumber
      age
      gender
      householdincome
      state
      transgender
      updatedAt
      zipcode
      originalSubmissionId
      __typename
    }
  }
`;
export const onUpdateDuplicateSubmission = /* GraphQL */ `
  subscription OnUpdateDuplicateSubmission(
    $filter: ModelSubscriptionDuplicateSubmissionFilterInput
  ) {
    onUpdateDuplicateSubmission(filter: $filter) {
      id
      SID
      createdAt
      mobilenumber
      age
      gender
      householdincome
      state
      transgender
      updatedAt
      zipcode
      originalSubmissionId
      __typename
    }
  }
`;
export const onDeleteDuplicateSubmission = /* GraphQL */ `
  subscription OnDeleteDuplicateSubmission(
    $filter: ModelSubscriptionDuplicateSubmissionFilterInput
  ) {
    onDeleteDuplicateSubmission(filter: $filter) {
      id
      SID
      createdAt
      mobilenumber
      age
      gender
      householdincome
      state
      transgender
      updatedAt
      zipcode
      originalSubmissionId
      __typename
    }
  }
`;
export const onCreateAppointmentSlot = /* GraphQL */ `
  subscription OnCreateAppointmentSlot(
    $filter: ModelSubscriptionAppointmentSlotFilterInput
  ) {
    onCreateAppointmentSlot(filter: $filter) {
      id
      date
      startTime
      endTime
      isBooked
      createdBy
      updatedBy
      createdAt
      updatedAt
      appointment {
        id
        slotId
        submissionId
        bookedAt
        status
        updatedBy
        notes
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const onUpdateAppointmentSlot = /* GraphQL */ `
  subscription OnUpdateAppointmentSlot(
    $filter: ModelSubscriptionAppointmentSlotFilterInput
  ) {
    onUpdateAppointmentSlot(filter: $filter) {
      id
      date
      startTime
      endTime
      isBooked
      createdBy
      updatedBy
      createdAt
      updatedAt
      appointment {
        id
        slotId
        submissionId
        bookedAt
        status
        updatedBy
        notes
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const onDeleteAppointmentSlot = /* GraphQL */ `
  subscription OnDeleteAppointmentSlot(
    $filter: ModelSubscriptionAppointmentSlotFilterInput
  ) {
    onDeleteAppointmentSlot(filter: $filter) {
      id
      date
      startTime
      endTime
      isBooked
      createdBy
      updatedBy
      createdAt
      updatedAt
      appointment {
        id
        slotId
        submissionId
        bookedAt
        status
        updatedBy
        notes
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const onCreateAppointment = /* GraphQL */ `
  subscription OnCreateAppointment(
    $filter: ModelSubscriptionAppointmentFilterInput
  ) {
    onCreateAppointment(filter: $filter) {
      id
      slotId
      slot {
        id
        date
        startTime
        endTime
        isBooked
        createdBy
        updatedBy
        createdAt
        updatedAt
        __typename
      }
      submissionId
      submission {
        id
        publicId
        SID
        createdAt
        mobilenumber
        age
        gender
        householdincome
        sendwelcomesms
        state
        transgender
        updatedAt
        zipcode
        Status
        updatedBy
        Notes
        userscore
        eligible
        needsAlternateTime
        alternateTimeRequestedAt
        __typename
      }
      bookedAt
      status
      updatedBy
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateAppointment = /* GraphQL */ `
  subscription OnUpdateAppointment(
    $filter: ModelSubscriptionAppointmentFilterInput
  ) {
    onUpdateAppointment(filter: $filter) {
      id
      slotId
      slot {
        id
        date
        startTime
        endTime
        isBooked
        createdBy
        updatedBy
        createdAt
        updatedAt
        __typename
      }
      submissionId
      submission {
        id
        publicId
        SID
        createdAt
        mobilenumber
        age
        gender
        householdincome
        sendwelcomesms
        state
        transgender
        updatedAt
        zipcode
        Status
        updatedBy
        Notes
        userscore
        eligible
        needsAlternateTime
        alternateTimeRequestedAt
        __typename
      }
      bookedAt
      status
      updatedBy
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteAppointment = /* GraphQL */ `
  subscription OnDeleteAppointment(
    $filter: ModelSubscriptionAppointmentFilterInput
  ) {
    onDeleteAppointment(filter: $filter) {
      id
      slotId
      slot {
        id
        date
        startTime
        endTime
        isBooked
        createdBy
        updatedBy
        createdAt
        updatedAt
        __typename
      }
      submissionId
      submission {
        id
        publicId
        SID
        createdAt
        mobilenumber
        age
        gender
        householdincome
        sendwelcomesms
        state
        transgender
        updatedAt
        zipcode
        Status
        updatedBy
        Notes
        userscore
        eligible
        needsAlternateTime
        alternateTimeRequestedAt
        __typename
      }
      bookedAt
      status
      updatedBy
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateMessageTemplate = /* GraphQL */ `
  subscription OnCreateMessageTemplate(
    $filter: ModelSubscriptionMessageTemplateFilterInput
  ) {
    onCreateMessageTemplate(filter: $filter) {
      id
      type
      content
      isActive
      createdAt
      updatedAt
      createdBy
      updatedBy
      __typename
    }
  }
`;
export const onUpdateMessageTemplate = /* GraphQL */ `
  subscription OnUpdateMessageTemplate(
    $filter: ModelSubscriptionMessageTemplateFilterInput
  ) {
    onUpdateMessageTemplate(filter: $filter) {
      id
      type
      content
      isActive
      createdAt
      updatedAt
      createdBy
      updatedBy
      __typename
    }
  }
`;
export const onDeleteMessageTemplate = /* GraphQL */ `
  subscription OnDeleteMessageTemplate(
    $filter: ModelSubscriptionMessageTemplateFilterInput
  ) {
    onDeleteMessageTemplate(filter: $filter) {
      id
      type
      content
      isActive
      createdAt
      updatedAt
      createdBy
      updatedBy
      __typename
    }
  }
`;
export const onCreateOffHoursConfig = /* GraphQL */ `
  subscription OnCreateOffHoursConfig(
    $filter: ModelSubscriptionOffHoursConfigFilterInput
  ) {
    onCreateOffHoursConfig(filter: $filter) {
      id
      isEnabled
      weekdayStartTime
      weekdayEndTime
      weekendStartTime
      weekendEndTime
      updatedAt
      updatedBy
      createdAt
      __typename
    }
  }
`;
export const onUpdateOffHoursConfig = /* GraphQL */ `
  subscription OnUpdateOffHoursConfig(
    $filter: ModelSubscriptionOffHoursConfigFilterInput
  ) {
    onUpdateOffHoursConfig(filter: $filter) {
      id
      isEnabled
      weekdayStartTime
      weekdayEndTime
      weekendStartTime
      weekendEndTime
      updatedAt
      updatedBy
      createdAt
      __typename
    }
  }
`;
export const onDeleteOffHoursConfig = /* GraphQL */ `
  subscription OnDeleteOffHoursConfig(
    $filter: ModelSubscriptionOffHoursConfigFilterInput
  ) {
    onDeleteOffHoursConfig(filter: $filter) {
      id
      isEnabled
      weekdayStartTime
      weekdayEndTime
      weekendStartTime
      weekendEndTime
      updatedAt
      updatedBy
      createdAt
      __typename
    }
  }
`;
export const onCreateAppointmentMessageVariantTemplate = /* GraphQL */ `
  subscription OnCreateAppointmentMessageVariantTemplate(
    $filter: ModelSubscriptionAppointmentMessageVariantTemplateFilterInput
  ) {
    onCreateAppointmentMessageVariantTemplate(filter: $filter) {
      id
      variantTrack
      messageType
      content
      isActive
      mrt
      response1
      response2
      createdAt
      updatedAt
      createdBy
      updatedBy
      __typename
    }
  }
`;
export const onUpdateAppointmentMessageVariantTemplate = /* GraphQL */ `
  subscription OnUpdateAppointmentMessageVariantTemplate(
    $filter: ModelSubscriptionAppointmentMessageVariantTemplateFilterInput
  ) {
    onUpdateAppointmentMessageVariantTemplate(filter: $filter) {
      id
      variantTrack
      messageType
      content
      isActive
      mrt
      response1
      response2
      createdAt
      updatedAt
      createdBy
      updatedBy
      __typename
    }
  }
`;
export const onDeleteAppointmentMessageVariantTemplate = /* GraphQL */ `
  subscription OnDeleteAppointmentMessageVariantTemplate(
    $filter: ModelSubscriptionAppointmentMessageVariantTemplateFilterInput
  ) {
    onDeleteAppointmentMessageVariantTemplate(filter: $filter) {
      id
      variantTrack
      messageType
      content
      isActive
      mrt
      response1
      response2
      createdAt
      updatedAt
      createdBy
      updatedBy
      __typename
    }
  }
`;
export const onCreateUserMessageVariant = /* GraphQL */ `
  subscription OnCreateUserMessageVariant(
    $filter: ModelSubscriptionUserMessageVariantFilterInput
  ) {
    onCreateUserMessageVariant(filter: $filter) {
      id
      submissionId
      submission {
        id
        publicId
        SID
        createdAt
        mobilenumber
        age
        gender
        householdincome
        sendwelcomesms
        state
        transgender
        updatedAt
        zipcode
        Status
        updatedBy
        Notes
        userscore
        eligible
        needsAlternateTime
        alternateTimeRequestedAt
        __typename
      }
      status
      variantTrack
      assignedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateUserMessageVariant = /* GraphQL */ `
  subscription OnUpdateUserMessageVariant(
    $filter: ModelSubscriptionUserMessageVariantFilterInput
  ) {
    onUpdateUserMessageVariant(filter: $filter) {
      id
      submissionId
      submission {
        id
        publicId
        SID
        createdAt
        mobilenumber
        age
        gender
        householdincome
        sendwelcomesms
        state
        transgender
        updatedAt
        zipcode
        Status
        updatedBy
        Notes
        userscore
        eligible
        needsAlternateTime
        alternateTimeRequestedAt
        __typename
      }
      status
      variantTrack
      assignedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteUserMessageVariant = /* GraphQL */ `
  subscription OnDeleteUserMessageVariant(
    $filter: ModelSubscriptionUserMessageVariantFilterInput
  ) {
    onDeleteUserMessageVariant(filter: $filter) {
      id
      submissionId
      submission {
        id
        publicId
        SID
        createdAt
        mobilenumber
        age
        gender
        householdincome
        sendwelcomesms
        state
        transgender
        updatedAt
        zipcode
        Status
        updatedBy
        Notes
        userscore
        eligible
        needsAlternateTime
        alternateTimeRequestedAt
        __typename
      }
      status
      variantTrack
      assignedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
